module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0012.jpg?v=6b711e7a";